/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getTouch = /* GraphQL */ `
  query GetTouch($id: ID!) {
    getTouch(id: $id) {
      id
      at
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listTouchs = /* GraphQL */ `
  query ListTouchs(
    $filter: ModelTouchFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTouchs(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        at
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
